// Corrected SettingsPage component
import { useEffect } from 'react';
import AuthenticatedLayout from '../Layouts/AuthenticatedLayout';
import Settings from '../Components/Settings';
import { useAuth } from "../context/AuthContext";

export default function SettingsPage({ auth }) {
  const { user } = useAuth(); // Fetch authenticated user from context

  useEffect(() => {
    document.title = 'Διαμόρφωση - Coffee Roast City';
}, []);

  return (
    <AuthenticatedLayout user={user}>
      <Settings /> 
    </AuthenticatedLayout>
  );
}
